import { captureException } from "@/utils/sentry";

const INIT_RETRY_DELAYS_MS = [2000, 4000, 8000];

type RunInitWithRetryOptions = {
  init: () => Promise<void>;
  delaysMs?: number[];
  sleep?: (ms: number) => Promise<void>;
};

export async function runInitWithRetry({
  init,
  delaysMs = INIT_RETRY_DELAYS_MS,
  sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
}: RunInitWithRetryOptions): Promise<void> {
  const maxAttempts = delaysMs.length + 1;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      await init();
      return;
    } catch (error) {
      const isLastAttempt = attempt === maxAttempts;

      if (isLastAttempt) {
        captureException(error, {
          type: "init-failure",
          attempts: attempt,
        });
        throw error;
      }

      await sleep(delaysMs[attempt - 1]);
    }
  }
}
